




























import {
  ref,
  onMounted,
  onUnmounted,
  defineComponent,
} from '@nuxtjs/composition-api'
import InputRegion from '@/components/Inputs/InputRegion.vue'

export default defineComponent({
  name: 'BlockDadataWithIcon',
  components: {
    InputRegion,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
  },
  setup(_, { emit }) {
    const inputEl = ref<any>(null)
    const showCross = ref<boolean>(false)

    const onInput = (data: any) => {
      emit('input-change', data)
    }
    const onFirstInput = (evt: any) => {
      inputEl.value = evt.target
      showCross.value = true
      inputEl.value.addEventListener('input', onDadataInput)
      document.removeEventListener('input', onFirstInput)
    }
    const onDadataInput = (evt: any) => {
      if (showCross.value !== !!evt.target.value.length)
        showCross.value = !!evt.target.value.length
    }
    const onClearClick = () => {
      inputEl.value.value = ''
      showCross.value = false
      inputEl.value.dispatchEvent(new Event('input'))
    }
    const initClearIcon = () => {
      document.addEventListener('input', onFirstInput)
    }
    const deactivateClearIcon = () => {
      document.removeEventListener('input', onDadataInput)
      document.removeEventListener('input', onFirstInput)
    }

    onMounted(initClearIcon)
    onUnmounted(deactivateClearIcon)

    return {
      showCross,
      onClearClick,
      onInput,
    }
  },
})
